import { useTranslation } from "react-i18next";
import { KTSVG } from "src/resources/helpers";

export interface IResponseRTS {
  message: string;
  processId: string;
  data: {
    ordersn: string;
    statusRts: string;
  }[];
}

export const RTSOrderModal = ({
  isOpen,
  responseRTS,
  onClose,
}: {
  isOpen: boolean;
  responseRTS: IResponseRTS;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div className="modal show d-block">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header py-3">
              <h5 className="modal-title m-0 p-0">
                {t("OrderList.Modal.ArrangeShipment")}
              </h5>
              <button
                className="btn btn-sm btn-light m-0 p-0"
                onClick={onClose}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon svg-icon-2x"
                />
              </button>
            </div>

            {/* Modal Body */}
            <div className="modal-body py-0 my-2">
              <p className="m-0 py-0 text-sm w-100 text-start">
                {t("OrderList.ArrangeShipment.ProcessId")} :{" "}
                {responseRTS?.processId}
              </p>
              <p className="m-0 py-0 text-sm w-100 text-start">
                {t("OrderList.ArrangeShipment.ProcessMessage")} :{" "}
                {responseRTS?.message}
              </p>

              {/* Orders List From Response */}
              <div
                className="table-responsive mt-2 border border-gray border-2 rounded"
                style={{
                  maxHeight: "320px",
                  overflowY: "auto",
                }}
              >
                <table className="table">
                  <thead className="sticky-top bg-secondary text-dark">
                    <tr className="align-middle">
                      <th className="w-auto text-wrap">
                        {t("OrderList.OrderNumber")}
                      </th>
                      <th className="w-auto text-wrap">
                        {t("Common.Modal.Column.Header.Status")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseRTS?.data?.length > 0 ? (
                      responseRTS?.data?.map((order) => (
                        <tr
                          key={order.ordersn}
                          style={{
                            position: "relative",
                          }}
                          className="align-middle border-bottom border-gray border-2 py-1 my-1 text-sm"
                        >
                          <td className="w-auto text-wrap">{order.ordersn}</td>
                          <td className="w-auto text-wrap">
                            {order.statusRts}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center">{t("Common.NoData")}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer py-3 my-0">
              <button onClick={onClose} className="btn btn-secondary my-0">
                {t("Common.Modal.Button.Close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
